<nav
  class="sidenav navbar navbar-vertical fixed-left navbar-expand-xs navbar-light bg-white"
  id="sidenav-main"
  (mouseover)="onMouseEnterSidenav()"
  (mouseout)="onMouseLeaveSidenav()"
>
  <perfect-scrollbar>
    <div class="scrollbar-inner">
      <div class="sidenav-header d-flex align-items-center">
        <a class="navbar-brand" [routerLink]="permissionService.isAssistant() ? ['/patientList'] : ['/']">
          <img src="../../../assets/img/logo.png" alt="Logo" />
        </a>
        <div class="ml-auto">
          <div
            class="sidenav-toggler d-none d-xl-block"
            data-action="sidenav-unpin"
            data-target="#sidenav-main"
            (click)="minimizeSidebar()"
          >
            <div class="sidenav-toggler-inner">
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="navbar-inner">
        <div class="collapse navbar-collapse" id="sidenav-collapse-main">
          <ul class="navbar-nav">
            <li *ngFor="let menuitem of menuItems" class="nav-item">
              <a
                *ngIf="menuitem.type === 'link'"
                routerLinkActive="active"
                [routerLink]="[menuitem.path]"
                class="nav-link"
                (click)="applyGoogleAnalytics (menuitem.googleAnalyticsKey)"
              >
                <i *ngIf="!menuitem.icontype.includes('assets/')" class="ni {{ menuitem.icontype }}"></i>
                <img *ngIf="menuitem.icontype.includes('assets/')" [src]="menuitem.icontype" alt="{{ menuitem.title }}" class="nav-icon-img" />
                <span class="nav-link-text">{{ menuitem.title }}</span>
              </a>
              <a 
              *ngIf="menuitem.type === 'btn'" 
              href="javascript:void(0);" 
              class="nav-link" (click)="reportProblem()">
                <i *ngIf="!menuitem.icontype.includes('assets/')" class="ni {{ menuitem.icontype }}"></i>
                <img *ngIf="menuitem.icontype.includes('assets/')" [src]="menuitem.icontype" alt="{{ menuitem.title }}" class="nav-icon-img" />
                <span class="nav-link-text">{{ menuitem.title }}</span>
              </a>
              <a
                *ngIf="menuitem.type === 'sub'"
                data-toggle="collapse"
                routerLinkActive="active"
                (click)="menuitem.isCollapsed = !menuitem.isCollapsed"
                [attr.aria-expanded]="!menuitem.isCollapsed"
                [attr.aria-controls]="menuitem.collapse"
                class="nav-link"
              >
                <i *ngIf="!menuitem.icontype.includes('assets/')" class="ni {{ menuitem.icontype }}"></i>
                <img *ngIf="menuitem.icontype.includes('assets/')" [src]="menuitem.icontype" alt="{{ menuitem.title }}" class="nav-icon-img" />
                <span class="nav-link-text">{{ menuitem.title }}</span>
              </a>
              <div
                *ngIf="menuitem.type === 'sub'"
                id="{{ menuitem.collapse }}"
                class="collapse"
                [collapse]="menuitem.isCollapsed"
                [isAnimated]="true"
              >
                <ul class="nav nav-sm flex-column">
                  <li
                    *ngFor="let childitems of menuitem.children"
                    class="nav-item"
                  >
                    <a
                      *ngIf="childitems.type === 'link'"
                      routerLinkActive="active"
                      [routerLink]="[menuitem.path, childitems.path]"
                      class="nav-link"
                    >
                      {{ childitems.title }}
                    </a>
                    <a
                      *ngIf="childitems.type === 'sub'"
                      data-toggle="collapse"
                      (click)="childitems.isCollapsed = !childitems.isCollapsed"
                      [attr.aria-expanded]="!childitems.isCollapsed"
                      [attr.aria-controls]="childitems.collapse"
                      class="nav-link"
                    >
                      {{ childitems.title }}
                    </a>
                    <div
                      *ngIf="childitems.type === 'sub'"
                      id="{{ childitems.collapse }}"
                      class="collapse"
                      [collapse]="childitems.isCollapsed"
                      [isAnimated]="true"
                    >
                      <ul class="nav">
                        <li
                          *ngFor="let childitem of childitems.children"
                          class="nav-item"
                        >
                          <a [routerLink]="[menuitem.path, childitems.path, childitem.path]" class="nav-link">
                            {{ childitem.title }}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>
            </li>
            <li *ngIf="validateAdRole() && !isSideBarCollapsed" class="nav-item" id="Advertisment">
              <div>
                  <img class="nav-link" width="100%" height="120px" src="../../../assets/img/Ad2.jpeg">
              </div>
            </li>
          </ul>
          <hr class="my-3" />
        </div>
      </div>
      <!-- <div *ngIf="!doctorCarnivitaPermission">
        <app-ads-carosel></app-ads-carosel>
      </div> -->
    </div>
  </perfect-scrollbar>
</nav>
<!-- Google tag (gtag.js) -->
<script async src="https://www.googletagmanager.com/gtag/js?id=G-VE96YZWR72"></script>
<script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'G-VE96YZWR72');
</script>
